/**
 * Central home for user-facing copy that is otherwise scattered as inline
 * string literals across components, pages, and hooks — primarily status and
 * feedback messages (toasts, mutation success/error text, network errors).
 *
 * Edit copy here rather than at the call site. Strings are grouped by feature;
 * dynamic strings are functions (e.g. `net.requestFailed(status)`).
 *
 * Note: provider labels intentionally live alongside their config in
 * `../constants/providers.ts`, where the text is coupled to structural data;
 * resource-kind labels are owned by the backend handlers and arrive via
 * `/api/resource-kinds`.
 */
export const copy = {
  net: {
    unreachable:
      'Could not reach the server — check your connection and try again.',
    unauthorized: 'Your session has ended — sign in again.',
    requestFailed: (status: number) =>
      `Could not complete the request (HTTP ${status}) — try again.`,
    connectionLost: 'Connection lost — retrying in the background',
  },
} as const

export { accountCopy } from './account'
export { adminCopy } from './admin'
export { agentEditorCopy } from './agentEditor'
export { authCopy } from './auth'
export { brandCopy } from './brand'
export { consoleCopy } from './console'
export { contentCopy } from './content'
export { paginationCopy, runTraceCopy, tableCopy } from './data'
export { firstRunCopy } from './firstRun'
export { frameCopy } from './frame'
export { githubCopy } from './github'
export { ingressCopy } from './ingress'
export { keyLabels } from './keys'
export { overlayCopy } from './overlay'
export { paletteCopy } from './palette'
export { profilesCopy } from './profiles'
export { recipesCopy } from './recipes'
export { runsCopy } from './runs'
export { settingsCopy } from './settings'
export { shellCopy } from './shell'
export { skillsCopy } from './skills'
export { threadCopy } from './thread'
export { topicsCopy } from './topics'
